<div class="content-wrap" [ngClass]="{
	'attr-icon-top': attrFlipIconPosition==='upper',
	'attr-icon-bottom': attrFlipIconPosition==='lower', 
	'attr-icon-left': attrFlipIconPosition==='left',
	'attr-icon-right': attrFlipIconPosition==='right',
	'line-horizontal': centerline.horizontalVertical === 'hori',
	'line-vertical': centerline.horizontalVertical === 'vert',
	'second-line': centerlineIdx !== 0}">
	<div class="attr-flip-icon" title="Left-Right Switch">
		<mat-icon svgIcon="icon-reverse" (click)="flipRoadAttrs()"></mat-icon>
	</div>
	<div *ngIf="isRelativePosConsistentWithDirection&&isLinesDirectionSame" class="tool-buttons" [ngClass]="{'swap-tool-order': centerline.direction==='W' || centerline.direction==='S'}">
		<div class="left-tool">
			<mat-icon *ngIf="!centerline.isFromLeftError&&!centerline.isToLeftError" svgIcon="{{centerlineIdx===0 ? 'icon-chevron-right' : 'icon-chevron-left'}}" title="Synchronous shift" (click)="clickJointChange('left')"></mat-icon>
			<mat-icon *ngIf="centerline.isFromLeftError||centerline.isToLeftError" svgIcon="{{centerlineIdx===0 ? 'icon-chevron-last-right' : 'icon-chevron-last-left'}}" title="Shift to connect" (click)="clickAttach('left')"></mat-icon>
		</div>
		<div class="right-tool">
			<mat-icon *ngIf="!centerline.isFromRightError&&!centerline.isToRightError" svgIcon="{{centerlineIdx===0 ? 'icon-chevron-right' : 'icon-chevron-left'}}" title="Synchronous shift" (click)="clickJointChange('right')"></mat-icon>
			<mat-icon *ngIf="centerline.isFromRightError||centerline.isToRightError" svgIcon="{{centerlineIdx===0 ? 'icon-chevron-last-right' : 'icon-chevron-last-left'}}" title="Shift to connect" (click)="clickAttach('right')"></mat-icon>
		</div>
	</div>
	<div class="flip-fromto-buttons" [ngClass]="{
		'flip-fromto-horizontal': centerline.direction==='E' || centerline.direction==='W', 
		'flip-fromto-vertical': centerline.direction==='N' || centerline.direction==='S'}">
		<mat-icon svgIcon="icon-resize-vertical" title="Flip From/To Measure" (click)="clickFlipFromTo(centerline.direction==='E' || centerline.direction==='N' ? 'left' : 'right')"></mat-icon>
		<mat-icon svgIcon="icon-resize-vertical" title="Flip From/To Measure" (click)="clickFlipFromTo(centerline.direction==='E' || centerline.direction==='N' ? 'right' : 'left')"></mat-icon>
	</div>
	<div class="centerline-wrap" [ngClass]="{'current-road': isCurrentRoad, 
		'additional-road': !isCurrentRoad, 
		'connected-end': connectedEnd }">
		<ng-container *ngIf="centerlineDirection==='E'">
			<div class="centerline-side">
				<app-rc-cell [column]="fromAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isFromLeftError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="toAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isToLeftError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
			<div class="road-draw">
				<div class="road-draw-inner">
					<div class="arrow-wrap">
						<div class="arrow-line"></div>
						<div class="arrow-point"></div>
					</div>
				</div>
			</div>
			<div class="centerline-side">
				<app-rc-cell [column]="fromAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isFromRightError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="toAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isToRightError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
		</ng-container>
		<ng-container *ngIf="centerlineDirection==='W'">
			<div class="centerline-side">
				<app-rc-cell [column]="toAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isToRightError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="fromAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isFromRightError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
			<div class="road-draw">
				<div class="road-draw-inner">
					<div class="arrow-wrap">
						<div class="arrow-point" style="transform: rotate(180deg);"></div>
						<div class="arrow-line"></div>
					</div>
				</div>
			</div>
			<div class="centerline-side">
				<app-rc-cell [column]="toAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isToLeftError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="fromAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isFromLeftError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
		</ng-container>
		<ng-container *ngIf="centerlineDirection==='N'">
			<div class="centerline-side">
				<app-rc-cell [column]="toAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isToLeftError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="fromAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isFromLeftError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
			<div class="road-draw">
				<div class="road-draw-inner">
					<div class="arrow-wrap arrow-vertical">
						<div class="arrow-point"></div>
						<div class="arrow-line"></div>
					</div>
				</div>
			</div>
			<div class="centerline-side">
				<app-rc-cell [column]="toAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isToRightError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="fromAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isFromRightError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
		</ng-container>
		<ng-container *ngIf="centerlineDirection==='S'">
			<div class="centerline-side">
				<app-rc-cell [column]="fromAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isFromRightError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="toAddrRightCol" [rcRecordItem]="centerline" [isError]="centerline.isToRightError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
			<div class="road-draw">
				<div class="road-draw-inner">
					<div class="arrow-wrap arrow-vertical">
						<div class="arrow-line"></div>
						<div class="arrow-point" style="transform: rotate(90deg);"></div>
					</div>
				</div>
			</div>
			<div class="centerline-side">
				<app-rc-cell [column]="fromAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isFromLeftError" (edit)="onEdit($event)"></app-rc-cell>
				<app-rc-cell [column]="toAddrLeftCol" [rcRecordItem]="centerline" [isError]="centerline.isToLeftError" (edit)="onEdit($event)"></app-rc-cell>
			</div>
		</ng-container>
		<mat-icon class="flip-icon" title="Reverse Direction" svgIcon="icon-reverse" (click)="flipRoadGeom()"></mat-icon>
	</div>
</div>